import { render, staticRenderFns } from "./LogMinimizacao.vue?vue&type=template&id=1c256620&scoped=true"
import script from "./LogMinimizacao.vue?vue&type=script&lang=js"
export * from "./LogMinimizacao.vue?vue&type=script&lang=js"
import style0 from "./LogMinimizacao.vue?vue&type=style&index=0&id=1c256620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c256620",
  null
  
)

export default component.exports